// pages/public/AssessmentForm.jsx
// The complete 106 question assessment form
// Section 2: Q3-Q98 Likert scale (0-4)
// Section 3: Q99-Q106 Bipolar 7-point org mapping

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../../context/AssessmentContext';

// All questions data
const LIKERT_QUESTIONS = [
  { n: 3,  t: 'I like to work towards long-term goals' },
  { n: 4,  t: 'I really enjoy change and variety' },
  { n: 5,  t: 'It is important to me that I am valued on the basis of my technical/professional competence' },
  { n: 6,  t: 'I really enjoy the opportunity to contribute my ideas' },
  { n: 7,  t: 'It is important to be firm and decisive' },
  { n: 8,  t: 'I am highly competitive and need to keep ahead' },
  { n: 9,  t: 'I am business focused and value competence in others' },
  { n: 10, t: 'I tend to act in the interests of the organization as a whole' },
  { n: 11, t: 'A clear direction will emerge as a result of being attentive to your environment and becoming aware of what is needed' },
  { n: 12, t: 'I value stability and tradition' },
  { n: 13, t: 'I enjoy helping other people out' },
  { n: 14, t: "If I'm unsure about something, I like to ask others and explore issues" },
  { n: 15, t: 'I like to include people in decisions and to ask them to contribute their ideas' },
  { n: 16, t: 'I dislike making decisions with little information' },
  { n: 17, t: 'People learn from their mistakes, and they should be encouraged to take some risks' },
  { n: 18, t: 'I value teamwork over formal organizational goals' },
  { n: 19, t: 'I seek clear outcomes that I can name and describe' },
  { n: 20, t: 'Life would be boring without change' },
  { n: 21, t: 'My work relationships are business-like and with a degree of formality' },
  { n: 22, t: 'If I go to a meeting, I expect to actively contribute rather than just attend' },
  { n: 23, t: 'Decisions should be made and implemented quickly' },
  { n: 24, t: 'I have a lot of energy and like to stay busy' },
  { n: 25, t: 'I am prepared to be bold and radical in the way I implement change' },
  { n: 26, t: 'My primary duty is to the business as a whole, not just towards my function or unit' },
  { n: 27, t: 'Achieving results often requires adapting your goals to changing conditions' },
  { n: 28, t: 'Tried and true approaches to solving problems are usually the best' },
  { n: 29, t: 'I need a climate of openness and trust where I work' },
  { n: 30, t: 'It is important to gather information and consult others before introducing new initiatives' },
  { n: 31, t: 'It is important to get the support of staff before making decisions' },
  { n: 32, t: 'Good decisions require seeing things from multiple points of view' },
  { n: 33, t: "Everybody should be genuinely committed their own and others' personal and longer-term development" },
  { n: 34, t: 'I value collaboration with my peers over conflict, even if it adversely affects my team' },
  { n: 35, t: 'I drive very hard towards goals and am not easily distracted' },
  { n: 36, t: 'I enjoy the challenge of change' },
  { n: 37, t: 'I prefer to work on things on my own' },
  { n: 38, t: 'I like knowing what is happening in the organization beyond my own area of responsibility' },
  { n: 39, t: "I've got clear boundaries on what is or is not negotiable" },
  { n: 40, t: 'I like working in a fast-paced environment' },
  { n: 41, t: 'Hard decisions must be made to ensure performance is maintained or improved' },
  { n: 42, t: "My duty is to support the organization's goals, even if that is hard on my team" },
  { n: 43, t: 'Going with the flow is more effective than sticking to your guns' },
  { n: 44, t: "If it ain't broken, don't fix it" },
  { n: 45, t: 'The ability to get along with others is really important' },
  { n: 46, t: "It's important for me to feel like I am making a contribution" },
  { n: 47, t: 'I have a consultative style and reach decisions in collaboration with others' },
  { n: 48, t: 'I prepare carefully before executing projects' },
  { n: 49, t: 'People do better if they feel valued for their efforts' },
  { n: 50, t: 'My primary loyalty is to my team' },
  { n: 51, t: 'You create your own future by having goals to work to' },
  { n: 52, t: "It's frustrating when people or events get in the way of making changes" },
  { n: 53, t: 'I get tired working closely with others for extended periods' },
  { n: 54, t: 'I feel confident in what I am saying when contributing to decisions' },
  { n: 55, t: 'Clarity of direction is more important than consultation' },
  { n: 56, t: 'I enjoy the pressure of delivering to tight time scales' },
  { n: 57, t: "It's important to change what is not working well" },
  { n: 58, t: "The organization's goals are primary, and the needs of individuals are secondary" },
  { n: 59, t: "It's more important to respond to events as they happen than to fixate on specific goals" },
  { n: 60, t: 'Things that have lasted the test of time are good' },
  { n: 61, t: 'I really like feeling part of a team' },
  { n: 62, t: 'I ask for feedback or advice, so I can improve what I do' },
  { n: 63, t: "It's important to build a consensus before implementing decisions" },
  { n: 64, t: "I don't like to make decisions without adequate preparation" },
  { n: 65, t: 'I have a positive attitude and help promote a sense of personal growth and opportunity' },
  { n: 66, t: 'Managers must protect and nurture team members in a difficult organizational environment' },
  { n: 67, t: 'I keep my home and work lives clearly separate' },
  { n: 68, t: 'Change is a positive thing' },
  { n: 69, t: 'In my life, I have focused on future achievements' },
  { n: 70, t: 'I enjoy teaching and coaching others by sharing my own knowledge and experience' },
  { n: 71, t: 'Managers must make the decisions at work' },
  { n: 72, t: 'I feel the need to take action' },
  { n: 73, t: "Sometimes I've had to let people go" },
  { n: 74, t: "A manager has to meet the organization's needs, even when they conflict with the needs and preferences of their team" },
  { n: 75, t: 'I respond quickly to urgent matters, whatever the original plan' },
  { n: 76, t: 'Stability and security are important at work' },
  { n: 77, t: 'Getting along with people is the key to success' },
  { n: 78, t: "It's important to have a good understanding of a subject before acting" },
  { n: 79, t: 'I have a democratic and inclusive approach' },
  { n: 80, t: 'I carefully think things through before reaching decisions' },
  { n: 81, t: 'I coach and help others if I can, even if they are just a colleague' },
  { n: 82, t: "It's important to support people so they are prepared to act" },
  { n: 83, t: 'I am uncomfortable without clear goals to work towards' },
  { n: 84, t: "Things stagnate if we don't constantly challenge how they get done" },
  { n: 85, t: "I don't like people who are overly friendly at work" },
  { n: 86, t: 'I propose solutions rather than just pointing out problems' },
  { n: 87, t: 'Once I make a decision, I expect others to follow it, even if they disagree.' },
  { n: 88, t: 'The quicker you work, the more you achieve' },
  { n: 89, t: 'I like working in a challenging environment' },
  { n: 90, t: 'The primary responsibility of a manager is to deliver the objectives of the organization, not to address the wants and needs of individual team members' },
  { n: 91, t: 'I seldom try new approaches unless they have been well demonstrated' },
  { n: 92, t: 'The most important thing is adapting to the current situation, rather than being rigid about your goals' },
  { n: 93, t: 'Respect and loyalty between colleagues is very important to me' },
  { n: 94, t: 'It is important to take time to look, listen and learn' },
  { n: 95, t: 'If people are invested in decisions, they take more responsibility for outcomes' },
  { n: 96, t: 'I am often the person who suggests taking time to think before committing to action' },
  { n: 97, t: 'Seeing somebody I helped move on to better things provides me with satisfaction' },
  { n: 98, t: 'Leaders should be expected to represent and defend their teams' },
];

const ORG_QUESTIONS = [
  { n: 99,  left: 'Sticking to its objectives and strategies', right: 'Adjusting to changing conditions',       t: 'Where on the scale below does your organization run best?' },
  { n: 100, left: 'Shake things up',                          right: 'Maintain stability',                     t: "Where on the scale below would you characterize your organization's business goal?" },
  { n: 101, left: 'Keep a formal distance',                   right: 'Develop familiar, casual bonds',          t: 'Where on the scale below would you characterize successful work relationships in your organization?' },
  { n: 102, left: 'They immediately contribute value',        right: 'They learn and ask for help',             t: 'What does the organization expect of new leaders?' },
  { n: 103, left: 'Impose decisions where responsibility lies', right: 'Facilitate consensus among stakeholders', t: 'What does your organization need in decision-making style?' },
  { n: 104, left: 'Go fast to make change',                   right: 'Go slow to prepare for change',           t: 'What is the pace of change required in your organization?' },
  { n: 105, left: 'Replace them with more competent people',  right: 'Develop them',                           t: 'What does the organization need to do about employees who are currently not up to the task?' },
  { n: 106, left: 'Support the greater good',                 right: 'Support their team',                     t: "Where does the organization expect a leader's loyalties to lie?" },
];

const LIKERT_OPTIONS = [
  { value: 0, label: 'Strongly Disagree' },
  { value: 1, label: 'Disagree' },
  { value: 2, label: 'Neither' },
  { value: 3, label: 'Agree' },
  { value: 4, label: 'Strongly Agree' },
];

const QUESTIONS_PER_PAGE = 10;

const AssessmentForm = () => {
  const navigate = useNavigate();
  const { user, answers, saveAnswer, saveProgress, submitAssessment, loading, sessionToken } = useAssessment();

  const [section, setSection] = useState(1); // 1 = intro, 2 = likert, 3 = org mapping
  const [page, setPage] = useState(0);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Redirect if no user
  useEffect(() => {
    if (!user && !sessionToken) {
      navigate('/start');
    }
  }, [user, sessionToken, navigate]);

  // Auto save every 10 answers
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (answers.length > 0 && answers.length % 10 === 0) {
      saveProgress(answers, answers.length);
    }
  }, [answers.length]);

  const totalLikertPages = Math.ceil(LIKERT_QUESTIONS.length / QUESTIONS_PER_PAGE);
  const currentPageQuestions = LIKERT_QUESTIONS.slice(
    page * QUESTIONS_PER_PAGE,
    (page + 1) * QUESTIONS_PER_PAGE
  );

  const getAnswer = (questionNumber) => {
    const found = answers.find(a => a.questionNumber === questionNumber);
    return found?.score ?? null;
  };

  const allCurrentAnswered = () => {
    if (section === 2) {
      return currentPageQuestions.every(q => getAnswer(q.n) !== null);
    }
    if (section === 3) {
      return ORG_QUESTIONS.every(q => getAnswer(q.n) !== null);
    }
    return true;
  };

  const totalAnswered = answers.length;
  const totalQuestions = LIKERT_QUESTIONS.length + ORG_QUESTIONS.length;
  const progressPercent = Math.round((totalAnswered / totalQuestions) * 100);

  const handleLikertAnswer = (questionNumber, value) => {
    saveAnswer(questionNumber, value);
  };

  const handleOrgAnswer = (questionNumber, value) => {
    saveAnswer(questionNumber, value);
  };

  const handleNextPage = () => {
    if (!allCurrentAnswered()) {
      setError('Please answer all questions on this page before continuing');
      return;
    }
    setError('');
    if (page < totalLikertPages - 1) {
      setPage(prev => prev + 1);
      window.scrollTo(0, 0);
    } else {
      setSection(3);
      window.scrollTo(0, 0);
    }
  };

  const handlePrevPage = () => {
    setError('');
    if (section === 3) {
      setSection(2);
      setPage(totalLikertPages - 1);
    } else if (page > 0) {
      setPage(prev => prev - 1);
    }
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    if (!allCurrentAnswered()) {
      setError('Please answer all questions before submitting');
      return;
    }
    setError('');
    setSubmitting(true);

    const result = await submitAssessment(answers);

    if (result?.success) {
      navigate(`/results/${result.data.submissionId}`);
    } else {
      setError(result?.error || 'Submission failed. Please try again.');
      setSubmitting(false);
    }
  };

  // Intro screen
  if (section === 1) {
    return (
      <div style={styles.page}>
        <div style={styles.header}>
          <div style={styles.logo}>
            <span style={styles.logoExec}>EXECUTIVE</span>
            <span style={styles.logoSpring}>Springboard</span>
          </div>
        </div>
        <div style={styles.container} className="esb-container">
          <div style={styles.introCard} className="esb-card-lg">
            <div style={styles.introIcon}>📋</div>
            <h1 style={styles.introTitle}>Welcome to the Comfort Zone Assessment</h1>
            <p style={styles.introText}>
              Hi {user?.firstName}! You are about to complete the Executive Springboard
              Comfort Zone Assessment. This assessment will map your leadership preferences
              across 8 critical dimensions.
            </p>
            <div style={styles.introPoints}>
              <div style={styles.introPoint}><span style={styles.introPointIcon}>⏱</span> Takes approximately 15 to 20 minutes</div>
              <div style={styles.introPoint}><span style={styles.introPointIcon}>💾</span> Your progress is saved automatically</div>
              <div style={styles.introPoint}><span style={styles.introPointIcon}>🤔</span> Answer honestly without overthinking</div>
              <div style={styles.introPoint}><span style={styles.introPointIcon}>📊</span> 106 questions across two sections</div>
            </div>
            <p style={styles.introNote}>
              The following survey measures your preferences on aspects critical to success.
              You will find a series of quick questions. Please answer <strong>all</strong> of
              them without overthinking them. We will map your comfort zone on eight dimensions.
            </p>
            <button style={styles.btnStart} onClick={() => setSection(2)}>
              Start Assessment →
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>

      {/* Header */}
      <div style={styles.header}>
        <div style={styles.logo}>
          <span style={styles.logoExec}>EXECUTIVE</span>
          <span style={styles.logoSpring}>Springboard</span>
        </div>
        <div style={styles.headerProgress}>
          <div style={styles.headerProgressBar}>
            <div style={{ ...styles.headerProgressFill, width: `${progressPercent}%` }} />
          </div>
          <span style={styles.headerProgressText}>{progressPercent}% complete</span>
        </div>
      </div>

      <div style={styles.container} className="esb-container">

        {/* Section header */}
        <div style={styles.sectionHeader}>
          {section === 2 ? (
            <>
              <div style={styles.sectionTag}>Section 1 of 2</div>
              <h2 style={styles.sectionTitle}>Your Comfort Zone</h2>
              <p style={styles.sectionSubtitle}>
                Rate your agreement with each statement. Answer instinctively.
              </p>
              <div style={styles.pageInfo}>
                Page {page + 1} of {totalLikertPages} &nbsp;·&nbsp; Questions {page * QUESTIONS_PER_PAGE + 1} to {Math.min((page + 1) * QUESTIONS_PER_PAGE, LIKERT_QUESTIONS.length)} of {LIKERT_QUESTIONS.length}
              </div>
            </>
          ) : (
            <>
              <div style={styles.sectionTag}>Section 2 of 2</div>
              <h2 style={styles.sectionTitle}>Mapping Your Organization</h2>
              <p style={styles.sectionSubtitle}>
                For each dimension below, indicate where your organization sits on the scale from 1 to 7.
              </p>
            </>
          )}
        </div>

        {error && <div style={styles.errorBox}>{error}</div>}

        {/* Likert Questions */}
        {section === 2 && (
          <div style={styles.questionsList}>
            {currentPageQuestions.map((q, idx) => (
              <div key={q.n} style={styles.questionCard} className="esb-question-card">
                <div style={styles.questionNumber}>Q{page * QUESTIONS_PER_PAGE + idx + 1}</div>
                <p style={styles.questionText}>{q.t}</p>
                <div style={styles.likertOptions} className="esb-likert">
                  {LIKERT_OPTIONS.map(opt => (
                    <button
                      key={opt.value}
                      className="esb-likert-btn"
                      style={{
                        ...styles.likertBtn,
                        ...(getAnswer(q.n) === opt.value ? styles.likertBtnSelected : {}),
                      }}
                      onClick={() => handleLikertAnswer(q.n, opt.value)}
                    >
                      <span style={styles.likertValue}>{opt.value}</span>
                      <span style={styles.likertLabel}>{opt.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Org Mapping Questions */}
        {section === 3 && (
          <div style={styles.questionsList}>
            {ORG_QUESTIONS.map((q, idx) => (
              <div key={q.n} style={styles.questionCard} className="esb-question-card">
                <div style={styles.questionNumber}>Q{idx + 1}</div>
                <p style={styles.questionText}>{q.t}</p>
                <div style={styles.bipolarWrap} className="esb-bipolar">
                  <span style={styles.bipolarLeft}>{q.left}</span>
                  <div style={styles.bipolarOptions}>
                    {[1, 2, 3, 4, 5, 6, 7].map(val => (
                      <button
                        key={val}
                        style={{
                          ...styles.bipolarBtn,
                          ...(getAnswer(q.n) === val ? styles.bipolarBtnSelected : {}),
                        }}
                        onClick={() => handleOrgAnswer(q.n, val)}
                      >
                        {val}
                      </button>
                    ))}
                  </div>
                  <span style={styles.bipolarRight}>{q.right}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Navigation */}
        <div style={styles.navButtons} className="esb-nav-buttons">
          <button
            style={styles.btnBack}
            onClick={handlePrevPage}
            disabled={section === 2 && page === 0}
          >
            ← Back
          </button>

          {section === 3 ? (
            <button
              style={styles.btnSubmit}
              onClick={handleSubmit}
              disabled={submitting || loading}
            >
              {submitting ? 'Submitting...' : 'Submit Assessment →'}
            </button>
          ) : (
            <button style={styles.btnNext} onClick={handleNextPage}>
              {page < totalLikertPages - 1 ? 'Next Page →' : 'Continue to Section 2 →'}
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

const styles = {
  page: { minHeight: '100vh', backgroundColor: 'var(--color-off-white)', fontFamily: 'var(--font-primary)' },
  header: { backgroundColor: 'var(--color-primary)', padding: '0 24px', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 },
  logo: { display: 'flex', flexDirection: 'column', gap: '1px' },
  logoExec: { fontSize: '9px', fontWeight: '700', letterSpacing: '3px', color: 'var(--color-teal)', lineHeight: 1 },
  logoSpring: { fontSize: '18px', fontWeight: '700', color: '#FFFFFF', lineHeight: 1 },
  headerProgress: { display: 'flex', alignItems: 'center', gap: '10px' },
  headerProgressBar: { width: '140px', height: '6px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '100px', overflow: 'hidden' },
  headerProgressFill: { height: '100%', backgroundColor: 'var(--color-teal)', borderRadius: '100px', transition: 'width 0.3s ease' },
  headerProgressText: { fontSize: '12px', color: 'rgba(255,255,255,0.7)', whiteSpace: 'nowrap' },
  container: { maxWidth: '760px', margin: '0 auto', padding: '40px 24px 80px' },

  // Intro
  introCard: { backgroundColor: '#fff', borderRadius: '16px', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-md)', padding: '48px', textAlign: 'center' },
  introIcon: { fontSize: '48px', marginBottom: '20px' },
  introTitle: { fontSize: '28px', fontWeight: '700', color: 'var(--color-primary)', marginBottom: '16px' },
  introText: { fontSize: '16px', color: 'var(--color-text-light)', lineHeight: '1.7', marginBottom: '28px', maxWidth: '500px', margin: '0 auto 28px' },
  introPoints: { display: 'flex', flexDirection: 'column', gap: '10px', textAlign: 'left', maxWidth: '360px', margin: '0 auto 28px', backgroundColor: 'var(--color-off-white)', borderRadius: '12px', padding: '20px 24px' },
  introPoint: { fontSize: '14px', color: 'var(--color-text)', display: 'flex', alignItems: 'center', gap: '10px' },
  introPointIcon: { fontSize: '16px' },
  introNote: { fontSize: '14px', color: 'var(--color-text-light)', lineHeight: '1.7', marginBottom: '32px', maxWidth: '500px', margin: '0 auto 32px' },
  btnStart: { backgroundColor: 'var(--color-teal)', color: '#fff', padding: '14px 36px', borderRadius: '8px', border: 'none', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },

  // Section header
  sectionHeader: { marginBottom: '28px' },
  sectionTag: { fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: 'var(--color-teal)', textTransform: 'uppercase', marginBottom: '6px' },
  sectionTitle: { fontSize: '26px', fontWeight: '700', color: 'var(--color-primary)', marginBottom: '6px' },
  sectionSubtitle: { fontSize: '15px', color: 'var(--color-text-light)', marginBottom: '8px' },
  pageInfo: { fontSize: '13px', color: 'var(--color-text-light)' },
  errorBox: { background: 'var(--color-error-bg)', color: 'var(--color-error)', border: '1px solid #F5C6CB', borderRadius: '8px', padding: '12px 16px', fontSize: '14px', marginBottom: '20px' },

  // Questions
  questionsList: { display: 'flex', flexDirection: 'column', gap: '16px' },
  questionCard: { backgroundColor: '#fff', borderRadius: '12px', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-sm)', padding: '24px 28px' },
  questionNumber: { fontSize: '11px', fontWeight: '600', color: 'var(--color-teal)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' },
  questionText: { fontSize: '16px', color: 'var(--color-text)', lineHeight: '1.6', marginBottom: '20px', fontWeight: '500' },

  // Likert
  likertOptions: { display: 'flex', gap: '8px', flexWrap: 'wrap' },
  likertBtn: { flex: 1, minWidth: '80px', padding: '10px 6px', borderRadius: '8px', border: '2px solid var(--color-border)', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' },
  likertBtnSelected: { border: '2px solid var(--color-teal)', backgroundColor: 'var(--color-info-bg)' },
  likertValue: { display: 'block', fontSize: '18px', fontWeight: '700', color: 'var(--color-primary)', lineHeight: 1.2 },
  likertLabel: { display: 'block', fontSize: '11px', color: 'var(--color-text-light)', marginTop: '4px', lineHeight: 1.3 },

  // Bipolar
  bipolarWrap: { display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' },
  bipolarLeft: { fontSize: '13px', color: 'var(--color-text-light)', flex: 1, textAlign: 'right', minWidth: '120px' },
  bipolarRight: { fontSize: '13px', color: 'var(--color-text-light)', flex: 1, textAlign: 'left', minWidth: '120px' },
  bipolarOptions: { display: 'flex', gap: '8px' },
  bipolarBtn: { width: '44px', height: '44px', borderRadius: '8px', border: '2px solid var(--color-border)', backgroundColor: '#fff', cursor: 'pointer', fontSize: '15px', fontWeight: '600', color: 'var(--color-text)', transition: 'all 0.15s' },
  bipolarBtnSelected: { border: '2px solid var(--color-teal)', backgroundColor: 'var(--color-teal)', color: '#fff' },

  // Nav buttons
  navButtons: { display: 'flex', justifyContent: 'space-between', marginTop: '32px', gap: '16px' },
  btnBack: { padding: '12px 24px', borderRadius: '8px', border: '2px solid var(--color-border)', backgroundColor: '#fff', color: 'var(--color-text)', fontSize: '15px', fontWeight: '500', cursor: 'pointer' },
  btnNext: { padding: '12px 32px', borderRadius: '8px', border: 'none', backgroundColor: 'var(--color-teal)', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: 'pointer' },
  btnSubmit: { padding: '12px 32px', borderRadius: '8px', border: 'none', backgroundColor: 'var(--color-primary)', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: 'pointer' },
};

export default AssessmentForm;
